import { useState, useEffect } from 'react';

/**
 * Custom hook to manage form state for accounting integration
 * Handles checkbox states, form values, and derived disabled states
 */
export const useAccountingIntegrationFormState = (connectionState, myobDisconnectLoaded, xeroDisconnectLoaded) => {
  const [connectStatusLoading, setConnectStatusLoading] = useState(false);
  const [xeroTermsAndConditionsChecked, setXeroTermsAndConditionsChecked] = useState(false);
  const [myobTermsAndConditionsChecked, setMyobTermsAndConditionsChecked] = useState(false);

  const [formValues, setFormValues] = useState({
    xeroTermsAndConditions: false,
    myobTermsAndConditions: false,
  });

  // Derive button and checkbox disabled states
  const xeroConnectButtonDisabled = !xeroTermsAndConditionsChecked || connectionState.myobConnected;
  const myobConnectButtonDisabled = !myobTermsAndConditionsChecked || connectionState.xeroConnected;
  const xeroTermsAndConditionsDisabled = connectionState.xeroConnected || connectionState.myobConnected;
  const myobTermsAndConditionsDisabled = connectionState.xeroConnected || connectionState.myobConnected;

  // Sync form state when enrolment status changes
  useEffect(() => {
    if (connectionState.myobConnected) {
      setFormValues({ myobTermsAndConditions: true });
      setMyobTermsAndConditionsChecked(true);
      if (connectStatusLoading) {
        setConnectStatusLoading(false);
      }
    } else if (connectionState.xeroConnected) {
      setFormValues({ xeroTermsAndConditions: true });
      setXeroTermsAndConditionsChecked(true);
      if (connectStatusLoading) {
        setConnectStatusLoading(false);
      }
    } else {
      setFormValues({ xeroTermsAndConditions: false, myobTermsAndConditions: false });
      setXeroTermsAndConditionsChecked(false);
      setMyobTermsAndConditionsChecked(false);
    }
  }, [connectionState.xeroConnected, connectionState.myobConnected, connectStatusLoading]);

  // Reset form state after MYOB disconnect
  useEffect(() => {
    if (myobDisconnectLoaded) {
      setFormValues({ myobTermsAndConditions: false });
      setMyobTermsAndConditionsChecked(false);
    }
  }, [myobDisconnectLoaded]);

  // Reset form state after Xero disconnect
  useEffect(() => {
    if (xeroDisconnectLoaded) {
      setFormValues({ xeroTermsAndConditions: false });
      setXeroTermsAndConditionsChecked(false);
    }
  }, [xeroDisconnectLoaded]);

  const handleFormChange = (values) => {
    setXeroTermsAndConditionsChecked(values.xeroTermsAndConditions);
    setMyobTermsAndConditionsChecked(values.myobTermsAndConditions);
  };

  return {
    formValues,
    xeroTermsAndConditionsChecked,
    myobTermsAndConditionsChecked,
    xeroConnectButtonDisabled,
    myobConnectButtonDisabled,
    xeroTermsAndConditionsDisabled,
    myobTermsAndConditionsDisabled,
    handleFormChange,
    connectStatusLoading,
    setConnectStatusLoading,
  };
};
